import {
  setColorEnhanceMode,
  setImageFilter,
  setProcess,
  setProcessColor,
  setTileMode,
} from '@explorer/actions/tiles';

export const buildTilesActions = storedState => {
  const actions = [];
  if (storedState.tiles) {
    if (storedState.tiles.mode) {
      actions.push(setTileMode(storedState.tiles.mode));
    }
    if (storedState.tiles.process) {
      actions.push(setProcess(storedState.tiles.process));
    }
    if (storedState.tiles.processColor) {
      actions.push(setProcessColor(storedState.tiles.processColor));
    }

    if (storedState.tiles.enhance) {
      actions.push(setColorEnhanceMode({mode: storedState.tiles.enhance.mode}));
    }
    if (storedState.tiles.enhance && storedState.tiles.enhance.filters) {
      for (const filterName in storedState.tiles.enhance.filters) {
        const value = storedState.tiles.enhance.filters[filterName];
        actions.push(setImageFilter({filterName, value}));
      }
    }
  }

  return actions;
};
